
/**
 * 
 */
export const evPerCharger = {
  2020: {
    inhabitants: 5,
    commuters: 4,
    visitors: 20
  },
  2021: {
    inhabitants: 5.6,
    commuters: 4.8,
    visitors: 24
  },
  2022: {
    inhabitants: 6.2,
    commuters: 5.6,
    visitors: 28
  },
  2023: {
    inhabitants: 6.8,
    commuters: 6.4,
    visitors: 32
  },
  2024: {
    inhabitants: 7.4,
    commuters: 7.2,
    visitors: 36
  },
  2025: {
    inhabitants: 8,
    commuters: 8,
    visitors: 40
  },
  2026: {
    inhabitants: 8,
    commuters: 8,
    visitors: 40
  },
  2027: {
    inhabitants: 8,
    commuters: 8,
    visitors: 40
  },
  2028: {
    inhabitants: 8,
    commuters: 8,
    visitors: 40
  },
  2029: {
    inhabitants: 8,
    commuters: 8,
    visitors: 40
  },
  2030: {
    inhabitants: 8,
    commuters: 8,
    visitors: 40
  },
}